export const PAGE_LEAVE_REQUEST = "kph:page-leave-request";
export const PAGE_LEAVE_COMPLETE = "kph:page-leave-complete";

/** Navigation and sign-out ask the mounted page before discarding local work.
 * A page may cancel synchronously; without a registered page, behavior is unchanged. */
export function requestPageLeave(): boolean {
  return window.dispatchEvent(new Event(PAGE_LEAVE_REQUEST, { cancelable: true }));
}

/** Successful sign-out releases the already-confirmed page before auth redirects.
 * Failed sign-out must keep its page guard and local work available for retry. */
export function completePageLeave(): void {
  window.dispatchEvent(new Event(PAGE_LEAVE_COMPLETE));
}
